import { Ramp } from '@goldwasserexchange/react-topmodel';
import { msg } from '@lingui/macro';
import * as React from 'react';
import { useLingui } from '@lingui/react';
import { NewsLetterBoxInput } from '../../../../../input';

export const NewsLetterBoxEmail = () => {
  const {
    _,
  } = useLingui();
  return (
    <Ramp rampName="emailContainer">
      <NewsLetterBoxInput
        name="email"
        type="email"
        placeholder={_(msg`Courriel`)}
        widthLines="full"
      />
    </Ramp>
  );
};
